import { Injectable } from '@angular/core';
import { HTTPAPIConfig, APIConfigMapping, VlDataService, VlHttpService, isNullOrUndefined } from 'shared-library';
import { Observable, Subject } from 'rxjs';
import { MOB_AND_WEB_ENTITIES } from '../../models/app-json';
import { SharedService } from '../Services/shared.service';
import { ToastrService } from 'ngx-toastr';
import { PageRearrangeService } from '../mobi-pages/services/page-rearrange.service';

@Injectable({
  providedIn: 'root'
})
export class WidgetPropertyFormService {

  constructor(private dataService: VlDataService, private httpService: VlHttpService,private sharedService:SharedService,private toastr:ToastrService,private pageRearrangeService:PageRearrangeService) { }
  customerExtraFields!:any;

  getEntitySubmissionData(entityId: string): any {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITY_SUBMISSIONS_DATA']);
      apiConfig.postData = {
        entity_id: entityId
      };
      return this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data);
          observer.complete();
        },
        error: (error: any) => {
          observer.error(error);
          observer.complete();
        }
      });
    })
  }

  getMobAndWebEntities(): any {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_MOB_AND_WEB_ENTITIES']);
      apiConfig.postData = {
        project_id: JSON.parse(localStorage.getItem('ProjectMetaData') as string)?.project_id
      };
      return this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: MOB_AND_WEB_ENTITIES[]) => {
          observer.next(data);
          observer.complete();
        },
        error: (error: any) => {
          observer.error([]);
          observer.complete();
        }
      });
    })
  }

  async addOrDeletePreviewPage(widget:any,preview:boolean,pages:any,currentPageId:any,applicationId:string) {
    let checkPreviewPageInWidget = widget.widgetConfig['previewPageId'];
    let previewPageIndex = isNullOrUndefined(checkPreviewPageInWidget) ?  -1 :  pages.findIndex((page:any) => page.pageId === checkPreviewPageInWidget);
    
    if(preview && isNullOrUndefined(checkPreviewPageInWidget)) {
      await this.fetchPreviewScreen(widget,applicationId,currentPageId,pages);
    }else if(preview == false && previewPageIndex >= 0){
      await this.deletePreviewScreen(widget,applicationId,pages);
    }
  }

  async fetchPreviewScreen(widget:any,applicationId:string,pageId:string,pages:any) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['FETCH_PREVIEW']);

    apiConfig.postData = {
      applicationId: applicationId,
      pageId: pageId,
      widgetId: widget.widgetId
    }

    const data = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          widget.widgetConfig['previewPageId'] = response?.previewPageId;
          this.pageRearrangeService.updateOrder(applicationId,pages.map((page:any) => page.pageId), response?.previewPageId, 'add');
          resolve(response);
        },
        complete: () => {
          this.sharedService.getAllPagesRefreshActionTrigger();
        },
        error: (err : any) => {
          this.toastr.error(err.error.result);
          resolve(err);
        }
      })
    }) 
  }

  async deletePreviewScreen(widget:any,applicationId:string,pages:any) : Promise<{result:any,status:boolean}> {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_PREVIEW']);
    apiConfig.postData = {
      applicationId: applicationId,
      previewPageId : widget.widgetConfig?.previewPageId ? widget.widgetConfig?.previewPageId : "",
      widgetId: widget.widgetId
    }
    return await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          this.pageRearrangeService.updateOrder(applicationId,pages.map((page:any) => page.pageId), widget.widgetConfig['previewPageId'], 'remove');
          resolve({result:response,status:true});
        },
        complete: () => {
          delete widget.widgetConfig['previewPageId'];
          this.sharedService.getAllPagesRefreshActionTrigger();
        },
        error: (err : any) => {
          resolve({result:err,status:false});
        }
      })

    })
  }

  async fetchAdditionalFields(){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['FETCH_ADDITIONAL_USERFORM_FIELDS']);
    const customer = JSON.parse(localStorage.getItem('customerInfo') || '{}');
    const customerId = customer?.customerId || '';
    apiConfig.postData = {
      REPLACE_CUSTOMER_ID: customerId,
    };
    await this.httpService.placeAPICall(apiConfig).subscribe({
      next:(response:any) =>{
        if(response.response && response.response.length > 0 ){
          let extraFieldsJson = response.response.find((data:any) => data.customerId === customerId);
          this.customerExtraFields = extraFieldsJson.customerExtraFields ?? [];
        }else{
          this.customerExtraFields = [];
        }
      },error:(error:any) => {

      }
    })
   }

  getUserExtraFields(){
    return this.customerExtraFields;
  }

  updateValidation(widget:any,applicationId:string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    apiConfig.postData = {
      'applicationId': applicationId,
      'widgetConfig': widget.widgetConfig,
      'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
      'widgetId': widget.widgetId
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
      },
      error: (err: any) => {
      }
    })
      }

  getEntitiesOrAttributes(payload: any): any {
        return new Observable((observer) => {
          const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);
          apiConfig.postData = payload
          return this.httpService.placeAPICall(apiConfig).subscribe({
            next: (data: any) => {
              observer.next(data?.data); 
              observer.complete(); 
            },
            error: (error: any) => {
              observer.error(error);
              observer.complete();
            }
          });
        })
      }

    // return widgets of the selected entity
    retriveWidgetsListFromEntiywithConfig(pageWidgetDetails: any) {
      return pageWidgetDetails?.flatMap((page: any) =>
          page.widget_details.map((widget: any) => ({
            widgetId: widget.widgetId,
            widgetLabel: widget.widgetLabel,
            widgetType: widget.widgetType,
            widgetDataSource: widget.widgetDataSource,
            widgetConfig: widget.widgetConfig,
          }))
        ) || [];
      }


      fetchEntity(entity_id: string,applicationId:string ) : any {
        let apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);
        apiConfig.postData = {
          application_id: applicationId,
          entity_id: entity_id,
          project_id: null,
          parent_entity_id: null
        }
         return  this.httpService.placeAPICall(apiConfig);
      }

    
      formatInToBasedWidgetIds(input: any[]): any[] {
        const result: any[] = [];
      
        input.forEach((item) => {
          if (item.filterType === 'widget') {
            item.basedWidgetIds.forEach((entity:any) => {
              const entityId = entity.entityId;
              entity.basedWidgetControlMapping.forEach((mapping:any) => {
                result.push({
                  entityId,
                  type: 'widget',
                  ref: mapping.dependentValue,
                  dependentValue: mapping.widgetId,
                });
              });
            });
          } else if (item.filterType === 'manual') {
            result.push({
              type: 'manual',
              ref: item.ref,
              dependentValue: item.dependentValue,
            });
          }
        });
      
        return result;
      }
    
      formatInToFiltersArray(data: any[]): any[] {
        let widgetData: any = {
          filterType: 'widget',
          basedEntitys: [],
          basedWidgetIds: [],
        };
        let widgetfilterExists = false;
      
        let manualData: any[] = [];
      
        data.forEach((item) => {
          if (item.type === 'widget') {
            widgetfilterExists = true;
            // Add entityId to basedEntitys if not already present
            if (!widgetData?.basedEntitys.includes(item.entityId)) {
              widgetData.basedEntitys.push(item.entityId);
            }
      
            // Find or create basedWidgetIds entry for this entityId
            let entityEntry = widgetData.basedWidgetIds.find(
              (entry: any) => entry.entityId === item.entityId
            );
      
            if (!entityEntry) {
              entityEntry = {
                entityId: item.entityId,
                basedWidgets: [], // Initialize basedWidgets
                basedWidgetControlMapping: [],
              };
              widgetData.basedWidgetIds.push(entityEntry);
            }
      
            // Add widgetId to basedWidgets if not already present
            if (!entityEntry.basedWidgets.includes(item.ref)) {
              entityEntry.basedWidgets.push(item.dependentValue);
            }
      
            // Add widgetId and dependentValue to basedWidgetControlMapping
            entityEntry.basedWidgetControlMapping.push({
              widgetId: item.dependentValue,
              dependentValue: item.ref,
            });
          } else if (item.type === 'manual') {
            // Add manual type data as is
            manualData.push({
              filterType: 'manual',
              ref: item.ref,
              dependentValue: item.dependentValue,
            });
          }
        });
      
        // Combine widget data and manual data
        
        const result = widgetfilterExists ? [widgetData, ...manualData] : [...manualData];
        return result;
      }


      

      private buttonLineItemConfig = new Subject<any>();   
      buttonLineItemConfig$: Observable<any> = this.buttonLineItemConfig.asObservable();
      

        setButtonLineItemConfig(widgetId:string,formValue:any,pageId:string,relatedWidgets:any){
          this.buttonLineItemConfig.next({widgetId:widgetId,actionConfig:formValue,pageId:pageId,widgets:relatedWidgets})
        }
}
